import React from 'react';
import styled from 'styled-components';

export interface IconProps {
  color?: string;
  children?: React.ReactNode;
}

interface StyledIconProps {
  color?: string;
  children?: React.ReactNode;
}

const StyledIcon = styled.div<StyledIconProps>`
  color: ${props => props.color || 'inherit'};
`;

const Icon = ({ children, color }: IconProps) => {
  const hasChildren = React.Children.count(children) > 0;
  
  return (
    <StyledIcon color={color}>
      {hasChildren ? <>{children}</> : null}
    </StyledIcon>
  );
};

Icon.defaultProps = {
  children: null,
  color: undefined,
};

export default Icon;
